// extracted by mini-css-extract-plugin
export default {"formbutton":"ButtonsCSS_formbutton__0855P"};